export default __webpack_public_path__ + "static/media/content-image_contact-page-intro.93f0cdfc.png";